import { render } from "./WisdomExamWinners.vue?vue&type=template&id=8f9c30c4&scoped=true"
import script from "./WisdomExamWinners.vue?vue&type=script&lang=js"
export * from "./WisdomExamWinners.vue?vue&type=script&lang=js"

import "./WisdomExamWinners.vue?vue&type=style&index=0&id=8f9c30c4&lang=css"
import "./WisdomExamWinners.vue?vue&type=style&index=1&id=8f9c30c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9c30c4"]])

export default __exports__